import type { Channel } from 'pusher-js';

type EventHandler<T> = (channel: Channel, payload: T) => void;

export default class Pubsub<T> {
  private events: Record<string, EventHandler<T>[]> = {};

  subscription(eventName: string, func: EventHandler<T>) {
    return {
      subscribe: () => {
        if (!this.events[eventName]) {
          this.events[eventName] = [];
        }

        this.events[eventName].push(func);
        console.log(`${func.name} has subscribed to ${eventName} topic!`);
      },

      unsubscribe: () => {
        if (this.events[eventName]) {
          this.events[eventName] = this.events[eventName].filter(
            (subscriber) => subscriber !== func
          );
          console.log(`${func.name} has unsubscribed from ${eventName} topic!`);
        }
      },
    };
  }

  publish(eventName: string, channel: Channel, payload: T) {
    const funcs = this.events[eventName];
    if (Array.isArray(funcs)) {
      funcs.forEach((func) => func(channel, payload));
    }
  }
}

export const pubsubEvents = {
  ADD_DRAFT: 'create-draft-post',
  PUBLISH_POST: 'create-post',
  UPDATE_POST: 'update-post',
  REVERT_TO_PRIOR_VERSION: 'revert-to-prior-version',
  CREATE_TEAM: 'create-team',
  UPDATE_TEAM: 'update-team',
  CREATE_MEMBER: 'create-member',
  DELETE_MEMBER: 'delete-member',
  CREATE_CHANNEL: 'create-channel',
  UPDATE_CHANNEL: 'update-channel',
  CHANNEL_ACCESS_GRANTED: 'channel-access-granted',
  CHANNEL_ACCESS_REMOVED: 'channel-access-removed',
  UPDATE_CLIENT_ADMINS: 'update-client-admins',
  ADD_CLIENT_ADMIN: 'add-client-admin',
  DELETE_CLIENT_ADMIN: 'delete-client-admin',
  CLIENT_ADMIN_ACCESS_GRANTED: 'client-admin-access-granted',
  CLIENT_ADMIN_ACCESS_REMOVED: 'client-admin-access-removed',
  STUDY_CONTACT_CONFIG_ADDED: 'study-contact-config-added',
  STUDY_CONTACT_CONFIG_UPDATED: 'study-contact-config-updated',
  STUDY_CONTACT_CONFIG_REMOVED: 'study-contact-config-removed',
  TEAM_CONTACT_ADDED: 'team-contact-added',
  TEAM_CONTACT_UPDATED: 'team-contact-updated',
  TEAM_CONTACT_DELETED: 'team-contact-deleted',
  INVITE_CREATED: 'invite-created',
};
